import React from 'react';
import { useTranslation } from 'react-i18next';
import { ManageOrders } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';

export function ManageOrdersPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('manage-orders-component.metatags.title'),
        description: t('manage-orders-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.manageOrders,
        index: false,
    });

    return (
        <FiltersProvider>
            <ManageOrders />
        </FiltersProvider>
    );
}
